'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = require('babel-runtime/helpers/extends');

var _extends7 = _interopRequireDefault(_extends6);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _actions = require('../actions');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var initialState = {
  mapZoom: 7,
  loadedLayers: {},
  mapType: null,
  addressSearch: false,
  visibility: {}
};
/*
 Nothing in this state, just storing the legends properties for future use.
 */

function kmapReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.GET_VIEW:
      {
        return (0, _assign2.default)({}, state, {
          mapZoom: action.view.zoom
        });
      }

    case _actions.SET_MAP_TYPE:
      return (0, _assign2.default)({}, state, {
        mapType: action.mapType
      });

    case _actions.LOAD_LAYER:
      // on success, update swift config in state
      return (0, _assign2.default)({}, state, {
        loadedLayers: (0, _extends7.default)({}, state.loadedLayers, (0, _defineProperty3.default)({}, action.layerName, true))
      });

    case _actions.REMOVE_LAYER:
      // on success, update swift config in state
      return (0, _assign2.default)({}, state, {
        loadedLayers: (0, _extends7.default)({}, state.loadedLayers, (0, _defineProperty3.default)({}, action.layerName, false))
      });

    case _actions.SEARCH_ADDRESS_REQUEST:
      return (0, _assign2.default)({}, state, {
        addressSearch: true
      });

    case _actions.SEARCH_ADDRESS_SUCCESS:
    case _actions.SEARCH_ADDRESS_FAILURE:
      return (0, _assign2.default)({}, state, {
        addressSearch: false
      });

    case _actions.SET_LAYER_VISIBILITY:
      {
        return (0, _assign2.default)({}, state, {
          visibility: (0, _extends7.default)({}, state.visibility, (0, _defineProperty3.default)({}, action.layerCategory, [(0, _extends7.default)({}, state.visibility[action.layerCategory], (0, _defineProperty3.default)({}, action.layerName, action.visible))]))
        });
      }

    default:
      return state;
  }
}

exports.default = kmapReducer;